import React, { useEffect, useState } from 'react';
import { Alert, Button, Col, Container, Form, Row, Spinner } from 'react-bootstrap';
import background from '../../img/background.jpg';
import { mainApiUrl } from '../../utils/consts';
import LogoComponent from '../Logo/LogoComponent';
import AppSpinner from '../Extras/AppSpinner/AppSpinner';
import queryString from 'query-string';
import './styles/recoverPassword.scss';

function ResetPasswordComponent(props) {

  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [confPassword, setConfPassword] = useState('');
  const [loading, setLoading] = useState(true);
  const [updatingPassword, setUpdatingPassword] = useState(false);
  const [error, setError] = useState('');
  const [invalidToken, setInvalidToken] = useState('');
  const [validated, setValidated] = useState(false);
  const [passwordChanged, setPasswordChanged] = useState(false);

  const values = queryString.parse(props.location.search);
  const { token } = values;

  useEffect(() => {
    if (updatingPassword) setError('');
  }, [updatingPassword]);

  useEffect(() => {
    checkToken();
  }, []);

  const checkToken = async () => {

    if (!token) {
      setInvalidToken('Este link ya no es válido. Inténtalo nuevamente.');
    } else {
      const verifyProm = await fetch(`${mainApiUrl}/password_reset/verify`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          token
        })
      });
  
      const verifyResp = await verifyProm.json();
      if (!verifyResp.success) setInvalidToken('Este link ya no es válido. Inténtalo nuevamente.');
    }

    setLoading(false);
  };

  const handleSubmit = async event => {
    event.preventDefault();
    event.stopPropagation();

    setValidated(true);

    const form = event.currentTarget;

    if (password !== confPassword) return alert('Las contraseñas deben coincidir.');

    if (form.checkValidity()) {
      setUpdatingPassword(true);

      const updatePasswordProm = await fetch(`${mainApiUrl}/password_reset/reset`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          token,
          code,
          newPassword: password
        })
      });

      const updatePasswordResp = await updatePasswordProm.json();

      if (updatePasswordResp.success) setPasswordChanged(true);
      else setError(updatePasswordResp.message || 'Un error inesperado ocurrió. Inténtalo más tarde.');

      setUpdatingPassword(false);
    }
  };

  return (
    <div className="reset-password-component">
      <div className="login-container" style={{ backgroundImage: `url(${background})` }}>
        <LogoComponent />
        <Container>
          <Row className="justify-content-center">
            <Col md={8}>
              <div className="form-container">
                {
                  loading ?
                  <AppSpinner /> :
                  invalidToken ?
                  <>
                    <h1 className="app-title" style={{ fontSize: '1.75rem', textAlign: 'center' }}>
                      {invalidToken}
                    </h1>
                  </> :
                  passwordChanged ?
                  <>
                    <h1 className="app-title" style={{ fontSize: '1.75rem', textAlign: 'center' }}>
                      Actualizaste tu contraseña correctamente. Ya puedes cerrar esta ventana.
                    </h1>
                    <div>
                      <Button className="app-button" onClick={() => props.history.push('/')}>
                        Ir al inicio
                      </Button>
                    </div>
                  </> :
                  <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Form.Row>
                      <Form.Group as={Col} md={12}>
                        <Form.Label className="app-label">Código de verificación</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Código de verificación"
                          value={code}
                          onChange={event => setCode(event.target.value)}
                          required
                        />
                        <Form.Text className="text-muted">
                          Te enviamos el código de verificación a tu correo electrónico junto con el link de reestablecimiento de contraseña.
                        </Form.Text>
                      </Form.Group>
                    </Form.Row>
                    <Form.Row>
                      <Form.Group as={Col} md={6}>
                        <Form.Label className="app-label">Nueva contraseña</Form.Label>
                        <Form.Control
                          type="password"
                          placeholder="Contraseña"
                          value={password}
                          onChange={event => setPassword(event.target.value)}
                          required
                        />
                      </Form.Group>
                      <Form.Group as={Col} md={6}>
                        <Form.Label className="app-label">Confirmar nueva contraseña</Form.Label>
                        <Form.Control
                          type="password"
                          placeholder="Confirmar contraseña"
                          value={confPassword}
                          onChange={event => setConfPassword(event.target.value)}
                          required
                        />
                      </Form.Group>
                    </Form.Row>

                    <Button type="submit" disabled={updatingPassword} className="app-button">
                      {
                        updatingPassword ? <Spinner animation="border" variant="warning" size="sm" /> : 'Confirmar'
                      }
                    </Button>
                    {
                      error &&
                      <>
                        <br />
                        <Alert variant="danger">
                          { error }
                        </Alert>
                      </>
                    }
                  </Form>
                }
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default ResetPasswordComponent;
